import "./App.css";
import { useHedayahData } from "./useHedayahData";
import LineAreaCombo from "./LineAreaCombo";
import SingleAxisChart from "./SingleAxisChart";
import config from "./config";
import SmallMultiples from "./SmallMultiples";
import StringencyMultiples from "./StringencyMultiples";

function App() {
  const {
    casesData,
    incidentData,
    annotationData,
    stringencyData,
    countries,
    labelsData,
    loading,
  } = useHedayahData(config.urls);

  const env = process.env.REACT_APP_STAGE;
  // const stringency = true;
  const stringency = false;

  return (
    <div className="App">
      <header>
        <div className="container">
          {!stringency && (<h1>{labelsData.title}</h1>)}
          {stringency && (<h1>{labelsData.stringencyTitle}</h1>)}
          {!stringency && (<span>{labelsData.subtitle}</span>)}
          {stringency && (<span>{labelsData.stringencySubtitle}</span>)}
        </div>
      </header>
      <div className="container">
        {loading && <div className="loading">Loading data, please wait...</div>}
        {!loading &&
          !stringency &&
          env !== "balkans" &&
          config.urls.incidentsUrl && (
            <LineAreaCombo
              annotations={annotationData}
              casesData={casesData}
              incidentData={incidentData}
              countries={countries}
              labels={labelsData}
              dimensions={config.dimensions}
            ></LineAreaCombo>
          )}
        {!loading &&
          !stringency &&
          env === "balkans" &&
          config.urls.incidentsUrl && (
            <SmallMultiples
              casesData={casesData}
              incidentData={incidentData}
              countries={countries}
              labels={labelsData}
              dimensions={config.dimensions}
              columns={3}
            ></SmallMultiples>
          )}
          {!loading &&
          stringency &&
          (
            <StringencyMultiples
              stringencyData={stringencyData}
              incidentData={incidentData}
              countries={countries}
              labels={labelsData}
              columns={3}
            ></StringencyMultiples>
          )}
        {!loading && !stringency && !config.urls.incidentsUrl && (
          <SingleAxisChart
            annotations={annotationData}
            casesData={casesData}
            countries={countries}
            labels={labelsData}
            dimensions={config.dimensions}
          ></SingleAxisChart>
        )}
        <div className="subtext-container">
          {!stringency && (<span className="subtext">{labelsData.subtext}</span>)}
          {stringency && (<span className="subtext">{labelsData.stringencySubtext}</span>)}
        </div>
      </div>
    </div>
  );
}

export default App;
